import useTheme from 'branding/theme';
import { useMemo } from 'react';
import useComponentPadding from '../../../hooks/useComponentPadding';
const useNavItemStyles = (isCurrent, styles) => {
    const { colors, typography } = useTheme();
    const paddingStyles = useComponentPadding({ padding: 'regular' });
    return useMemo(() => ({
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        textDecoration: 'none',
        backgroundColor: isCurrent ? colors.neutrals.borderBeta : colors.neutrals.background,
        ...typography.paragraph.regular,
        ...paddingStyles,
        ...styles
    }), [isCurrent, styles, paddingStyles, colors, typography]);
};
export default useNavItemStyles;
//# sourceMappingURL=useNavItemStyles.js.map